/**
 * Documentos legales que se aceptan en el alta.
 *
 * ── LEGAL_VERSION tiene que coincidir con la del backend ───────────────
 *
 * El alta manda esta versión y `verix-api` (`src/utils/legal.ts`) comprueba
 * que sea la vigente: si no lo es, responde 409 `LEGAL_VERSION_MISMATCH` en
 * vez de registrar la aceptación.
 *
 * Suena redundante, pero cubre un caso real: se actualiza un texto legal, se
 * despliega la API y CloudFront sigue sirviendo el bundle anterior del ERP.
 * Ese usuario lee el texto viejo, y guardar que aceptó el nuevo sería falso.
 * Mejor un alta rechazada —el usuario recarga y reintenta— que un
 * consentimiento que no se corresponde con lo que tuvo delante.
 *
 * Al cambiar un texto: sube la fecha AQUÍ y en `verix-api/src/utils/legal.ts`,
 * y despliega los dos. Mientras solo esté en uno, las altas fallan con 409.
 *
 * El valor es la fecha del más reciente de los dos documentos:
 *   · Términos y condiciones — 14 de septiembre de 2026
 *   · Política de privacidad  — 2 de septiembre de 2026
 */
export const LEGAL_VERSION = '2026-09-14';

/**
 * Los textos viven en la landing, que es donde ya se mantienen y se publican.
 * No se duplican aquí: dos copias del mismo texto legal acaban divergiendo, y
 * la que el usuario acepta tiene que ser la que está publicada.
 */
export const LEGAL_URLS = {
  // 22-09-2026 — los tres con `/es/`. La raíz sin prefijo sirve la versión en INGLÉS:
  // este sitio usa `/` para EN y `/es/` para ES, y el propio pie de la landing enlaza
  // `/es/legal/terminos/`, `/es/legal/privacidad/` y `/es/legal/declaracion-responsable/`.
  //
  // `terms` y `privacy` importan por un motivo distinto al de abajo: son los textos que el
  // usuario ACEPTA al registrarse (`Register.jsx`, `TermsGate.jsx`). Aceptar un texto que no
  // se puede leer en el idioma propio es peor que un enlace roto: un enlace roto se ve.
  terms: 'https://www.verix.es/es/legal/terminos/',
  privacy: 'https://www.verix.es/es/legal/privacidad/',
  // 22-09-2026 — con `/es/`. La raíz sin prefijo sirve la versión en INGLÉS: el sitio
  // usa `/` para EN y `/es/` para ES, y el propio pie de la landing enlaza
  // `/es/legal/declaracion-responsable/`. Verificado en navegador, no con `curl`: las
  // dos rutas devuelven 200 y el cuerpo inicial dice «Loading…», así que el código HTTP
  // no distingue el idioma ni prueba que la página exista.
  //
  // Importa más aquí que en un enlace cualquiera: es la declaración responsable del
  // art. 13 RRSIF, que tiene que constar «de modo visible» — y en el idioma del obligado
  // tributario al que se dirige.
  declaracionResponsable: 'https://www.verix.es/es/legal/declaracion-responsable/',
};
